// extracted by mini-css-extract-plugin
module.exports = {"Package":"Box_Package__IY9Mz","Indicator":"Box_Indicator__6o6e5"};